import { WEB_COMPONENT_SENSOR_AWS } from '../../../webcomponents.constants';
import { AwsSensorComponent } from './component/AwsSensorComponent';

export { AwsSensorComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_AWS, AwsSensorComponent);
